import DB from "@/common/utils/db";
import { uploadFile } from "@/common/utils/db";


//import axios from "axios";
// 接口文档 https://www.tapd.cn/31697456/prong/stories/view/1131697456001000786

/**
 * @description 获取link
 */
export function getLink(query) {
    return DB({
        url: "v1/user/logins/link",
        method: "get",
        params: query
    });
}

export function getUserInfo(query) {
    return DB({
        url: "v1/users/getUserInfo",
        method: "get",
        params: query
    });
}

/**
 * @description 账号名密码登录
 * @param  {string} loginName    手机号
 * @param {string} authorizeCode    md5加密，注意改变加密的url为：POST:/v1/user/logins/login
 * @param {string} twoAuthorizeCode 二次加密
 * @param {string} unionId unionId
 */
export function login(query) {
    return DB({
        url: "v1/user/logins/login",
        method: "post",
        params: query
    });
}

/**
 * @description 发送登录短信验证码
 * @param  {string} areaCode    手机号
 * @param {string} mobilePhone  手机号国际区号
 */
export function sendSmsLogin(query) {
    return DB({
        url: "v1/user/logins/sendSmsLogin",
        method: "post",
        params: query 
    });
}

/**
 * @description 短信验证码登录
 * @param  {string} areaCode    手机号
 * @param {string} mobilePhone  手机号国际区号
 * @param {string} smsVerifyCode  手机验证码
 * @param {string} unionId  unionId
 */
export function smsLogin(query) {
    return DB({
        url: "v1/user/logins/smsLogin",
        method: "post",
        params: query
    });
}


// ================猎企注册===============


/**
 * @description 第一步 验证猎企名是否已经存在
 */
export function isExistCompanyName(query) {
    return DB({
        url: "v1/companys/isExistCompanyName",
        method: "get",
        params: query
    });
}


/**
 * @description 第一步 验证公司简称是否已经存在
 */
export function isExistDisplayName(query) {
    return DB({
        url: "v1/companys/isExistDisplayName",
        method: "get",
        params: query
    });
}

/**
 * @description 第二步 获取短信验证码
 */

export function sendPhoneVerifyCode(query) {
    return DB({
        url: "v1/user/company/registers/sendPhoneVerifyCode",
        method: "post",
        params: query
    });
}



/**
 * @description 第二步 验证短信验证码
 */

export function checkCellPhone(query) {
    return DB({
        url: "v1/user/company/registers/checkCellPhone",
        method: "post",
        params: query
    });
}

//上传图片

export function uploadCompanyImage(query){
    return uploadFile({
        url:"/v1/companys/uploadCompanyImage",
        params:query
    })
}


// 猎企注册提交

export function registerCompany(query) {
    return DB({
        url: "v1/user/company/registers/registerCompany",
        method: "post",
        params: query
    });
}

// ================猎头注册===============

//验证短信验证码
export function sendRegSms(query) {
    return DB({
        url: "v1/user/registers/sendRegSms",
        method: "post",
        params: query
    });
}

// 猎头注册
export function joinCompany(query){
    return DB({
        url: "v1/user/registers/joinCompany",
        method: "post",
        params: query
    });
}

// root注册
export function registerUser(query){
    return DB({
        url: "v1/user/company/registers/registerUser",
        method: "post",
        params: query
    });
}

// 通过邀请码获得公司信息

export function getCompanyInfoByInviteCode(query) {
    return DB({
        url: "v1/user/company/registers/getCompanyInfoByInviteCode",
        method: "get",
        params: query
    });
}

//上传职业照

export function uploadAvatar(query){
    return uploadFile({
        url:"/v1/user/accounts/uploadAvatar",
        params:query
    })
}

//上传身份证

export function addOrUpdateUserAuthenticationFile(query){
    return uploadFile({
        url:"/v1/user/accounts/addOrUpdateUserAuthenticationFile",
        params:query
    })
}

// 查询认证状态
export function getUserAuthenticationView(query) {
    return DB({
        url: "v1/user/accounts/getUserAuthenticationView",
        method: "get",
        params: query
    });
}

//提交实名认证信息

export function saveUserAuthenticationInfo(query) {
    return DB({
        url: "v1/user/accounts/saveUserAuthenticationInfo",
        method: "post",
        params: query
    });
}